

export const communicationSearchSchema = [

    {
        name: 'Name',
        type: 'text',
        labelTitle: 'Nombre'
    },
    {
        name: 'LastName',
        type: 'text',
        labelTitle: 'Apellido'
    },
    {
        name: 'Dni',
        type: 'text',
        labelTitle: 'Nro de Documento'
    },
    {
        name: 'Email',
        type: 'text',
        labelTitle: 'Email o Teléfono'
    },
    {
        name: '',
        select: 'true',
        labelTitle: 'Estado'
    },
]